import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Icon from 'components/Icon';
import { FreemiumContext } from 'index/FreemiumProvider';

const formatRouteString = idString => {
  const input = idString?.replace(/[^\w\s]/gi, ' ');
  return input;
};
const PlayButton = ({
  isNationLicensed,
  text,
  route,
  seriesName,
  theme,
  thinIcon,
  segmentPlaylistButtonAction,
  id,
}) => {
  const { hasAccountOrProvider, isFreemium, setFreemiumModalVisibility } = useContext(
    FreemiumContext,
  );
  let icon = 'play-button';
  let viewBox = null;
  if (thinIcon) {
    icon = 'play-button-thin';
    viewBox = '1 1 36 36';
  }
  let url = route;
  const onClick =
    isFreemium && !hasAccountOrProvider && !isNationLicensed
      ? () => setFreemiumModalVisibility({ visibility: true, redirectUrl: route })
      : segmentPlaylistButtonAction;

  if (isFreemium && !hasAccountOrProvider && !isNationLicensed) {
    url = null;
  }
  return (
    <div className={theme.play}>
      <Link aria-label={`play ${seriesName || formatRouteString(id)}`} to={url} onClick={onClick}>
        <Icon icon={icon} color="white" size="full" viewBox={viewBox} />
        {text && <div className={theme.playText}>{text}</div>}
      </Link>
    </div>
  );
};

PlayButton.defaultProps = {
  isNationLicensed: false,
  text: null,
  thinIcon: false,
  route: null,
  segmentPlaylistButtonAction: () => {},
  id: null,
};

PlayButton.propTypes = {
  isNationLicensed: PropTypes.bool,
  text: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  thinIcon: PropTypes.bool,
  route: PropTypes.string,
  segmentPlaylistButtonAction: PropTypes.func,
  seriesName: PropTypes.string,
  id: PropTypes.string,
};

export default PlayButton;
